import { ReactElement } from 'react';

import { CopySvg } from '@cashier/cashier-assets';
import { PaymentFormField } from '@cashier/cashier-model';
import { useCopyToClipboard } from '@cashier/cashier-shared';

import { Label } from './label';

import styles from './styles.module.scss';

type InformationFieldListProps = {
  fields: PaymentFormField[];
};

export const InformationFieldList = ({
  fields,
}: InformationFieldListProps): ReactElement => {
  const { copyToClipboard } = useCopyToClipboard();
  return (
    <section className={styles.container}>
      <ul className={styles.list}>
        {fields.map((field, index) => (
          <li key={field.name} className={styles.listItem}>
            <Label value={field.label || ''} index={index} />
            <div className={styles.listItemValue}>
              {field.value}
              <button
                className={styles.copyButton}
                data-test="copy-button"
                onClick={() => copyToClipboard(field.value as string)}
              >
                <CopySvg />
              </button>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};
